import PropTypes from 'prop-types';
import {
  Container,
  Stack,
  Typography,
  Box,
  Slide,
  useMediaQuery,
  Button,
  Fade
} from '@mui/material';
import React from 'react';
import { useTheme, alpha } from '@mui/material/styles';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
//
import Page from '../Page';
import useWidth from '../../hooks/useWidth';

const LandingSection = ({ user }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const Layanans = [
    {
      id: 'rekomendasi',
      color: theme.palette.primary.dark,
      title: 'Rekomendasi',
      image: '/static/illustrations/undraw_book_lover_re_rwjy.svg',
      content: [
        {
          id: '1',
          type: 'paragraph',
          value:
            'Pelaksanaan rencana dan anggaran Sistem Pemerintahan Berbasis Elektronik oleh Organisasi Perangkat Daerah di lingkungan Pemerintah Daerah Daerah Istimewa Yogyakarta wajib disertai Rekomendasi TIK sebagaimana diamanatkan oleh Peraturan Gubernur DIY Nomor 67 Tahun 2022 tentang Sistem Pemerintahan Berbasis Elektronik Pemerintah Daerah Daerah Istimewa Yogyakarta. Rekomendasi diajukan oleh Organisasi Perangkat Daerah kepada Dinas Komunikasi dan Informatika Daerah Istimewa Yogyakarta.'
        },
        {
          id: '2',
          type: 'paragraph',
          value: 'Adapun tahapan pengajuan rekomendasi TIK adalah:'
        },
        {
          id: '3',
          type: 'list',
          value: [
            {
              id: '1',
              type: 'paragraph',
              value:
                'OPD melakukan pengajuan permohonan rekomendasi pelaksanaan investasi TIK kepada Kepala Dinas Komunikasi dan Informatika DIY pada n-1 tahun anggaran. Di dalam permohonan rekomendasi pelaksanaan investasi TIK, OPD melakukan:',
              child: [
                { id: '1', type: 'paragraph', value: 'analisis kebutuhan;' },
                { id: '2', type: 'paragraph', value: 'analisis biaya; dan' },
                {
                  id: '3',
                  type: 'paragraph',
                  value: 'analisis manfaat dari belanja TIK yang direncanakan.'
                }
              ]
            },
            {
              id: '2',
              type: 'paragraph',
              value:
                'Dinas Komunikasi dan Informatika menganalisis permohonan rekomendasi pelaksanaan investasi TIK dengan mengacu pada Renstra TIK.'
            },
            {
              id: '3',
              type: 'paragraph',
              value:
                'Berdasarkan hasil analisis sebagaimana dimaksud pada tahap 2, Dinas Komunikasi dan Informatika:',
              child: [
                { id: '1', type: 'paragraph', value: 'menerbitkan rekomendasi; atau' },
                { id: '2', type: 'paragraph', value: 'menolak permohonan.' }
              ]
            },
            {
              id: '4',
              type: 'paragraph',
              value:
                'Apabila permohonan rekomendasi ditolak, OPD melakukan penyesuaian atas pelaksanaan investasi TIK dalam rencana kerja anggaran sesuai saran Dinas Komunikasi dan Informatika.'
            }
          ]
        }
      ]
    },
    {
      id: 'subdomain',
      color: theme.palette.info.dark,
      title: 'Subdomain',
      image: '/static/illustrations/undraw_domain_names_re_0uun.svg',
      content: [
        {
          id: '1',
          type: 'paragraph',
          value:
            'Diskominfo DIY menyediakan layanan subdomain *.jogjaprov.go.id bagi OPD dan stakeholder Pemda DIY. Subdomain merupakan nama unik pengganti alamat IP untuk mempermudah mengakses alamat suatu Sistem Elektronik. Subdomain *.jogjaprov.go.id menunjukkan bahwa Sistem Elektronik tersebut dikelola oleh Pemda DIY.'
        }
      ]
    },
    {
      id: 'hosting',
      color: theme.palette.primary.main,
      title: 'Hosting',
      image: '/static/illustrations/undraw_secure_server_re_8wsq.svg',
      content: [
        {
          id: '1',
          type: 'paragraph',
          value:
            'Diskominfo DIY menyediakan layanan hosting untuk aplikasi-aplikasi yang dikelola OPD dan stakeholder Pemda DIY. Hosting adalah penyimpanan segala file dan data website agar aplikasi dapat berjalan dan diakses melalui internet. Lokasi hosting terletak pada Data Center Pemda DIY di Komplek Kepatihan dan merupakan amanat dari Peraturan Gubernur nomor 67 tahun 2022 tentang Tata Kelola Teknologi Informasi dan Komunikasi terutama pasal 15.'
        }
      ]
    },
    {
      id: 'email',
      color: theme.palette.warning.dark,
      title: 'Email',
      image: '/static/illustrations/undraw_mail_re_duel.svg',
      content: [
        {
          id: '1',
          type: 'paragraph',
          value:
            'Diskominfo DIY menyediakan layanan email dengan alamat https://mail.jogjaprov.go.id. Penggunaan email resmi Pemda DIY ini diharapkan dapat meningkatkan kepercayaan masyarakat dalam memberikan layanan publik dan menjalin komunikasi dengan instansi lainnya. Layanan email meliputi pembuatan email baru, reset password, tambah kuota email. Layanan email terdiri atas layanan email pribadi dan email instansi. Layanan email pribadi dapat dimanfaatkan oleh semua ASN Pemda DIY. Layanan email instansi dapat dimanfaatkan oleh seluruh OPD dengan menunjuk salah satu ASN sebagai penanggungjawab (PIC) akun.'
        }
      ]
    },
    {
      id: 'tte',
      color: theme.palette.success.dark,
      title: 'TTE',
      image: '/static/illustrations/undraw_secure_files_re_6vdh.svg',
      content: [
        {
          id: '1',
          type: 'paragraph',
          value:
            'Diskominfo DIY memberikan layanan penggunaan sertifikat elektronik yang diterbitkan oleh Balai Sertifikasi Elektronik (BSrE) Badan Siber dan Sandi Negara, dimana sertifikat elektronik ini dapat dipergunakan untuk penandatanganan dokumen secara elektronik melalui: https://sadewa.jogjaprov.go.id  maupun diintegrasikan dalam sebuah sistem elektronik. Dengan penggunaan sertifikat elektronik ini diharapkan dapat:'
        },
        {
          id: '2',
          type: 'list',
          value: [
            {
              id: '1',
              type: 'paragraph',
              value:
                'Meningkatkan keamanan informasi dan sistem elektronik yang dikelola Pemda DIY.'
            },
            {
              id: '2',
              type: 'paragraph',
              value:
                'Meningkatkan kapabilitas dan tata kelola keamanan informasi dalam penyelenggaraan sistem elektronik di Pemda DIY.'
            },
            {
              id: '3',
              type: 'paragraph',
              value: 'Menjamin keutuhan, otentikasi dan nir penyangkalan dokumen elektronik.'
            },
            {
              id: '4',
              type: 'paragraph',
              value: 'Meningkatkan efektifitas pelayanan publik dan kepercayaan masyarakat.'
            }
          ]
        },
        {
          id: '3',
          type: 'paragraph',
          value: ''
        },
        {
          id: '4',
          type: 'paragraph',
          value: 'Bentuk layanan pemanfaatan sertifikat elektronik tersebut antara lain:'
        },
        {
          id: '5',
          type: 'list',
          value: [
            {
              type: 'paragraph',
              id: '1',
              value: 'Pendaftaran dan verifikasi dokumen Sertifikat Elektronik.'
            },
            {
              type: 'paragraph',
              id: '2',
              value: 'Pendampingan Penerbitan Sertifikat Elektronik.'
            },
            {
              type: 'paragraph',
              id: '3',
              value: 'Pendampingan implementasi sertifikat elektronik.'
            },
            {
              type: 'paragraph',
              id: '4',
              value: 'Pendampingan penggunaan sertifikat elektronik dengan Aplikasi Sadewa.'
            },
            {
              type: 'paragraph',
              id: '5',
              value: 'Pembaharuan sertifikat elektronik.'
            },
            {
              type: 'paragraph',
              id: '6',
              value: 'Pencabutan sertifikat elektronik.'
            }
          ]
        }
      ]
    },
    {
      id: 'cloudstorage',
      color: theme.palette.error.dark,
      title: 'Cloud Storage',
      image: '/static/illustrations/undraw_cloud_files_wmo8.svg',
      content: [
        {
          type: 'paragraph',
          id: '1',
          value:
            'Diskominfo DIY menggunakan teknologi opensource OwnCloud pada alamat https://cloud.jogjaprov.go.id, yang dapat digunakan untuk menyimpan dan berbagi file secara online seperti Google Drive, Dropbox, dll. Sistem ini sudah terintegrasi dengan email Pemda DIY, sehingga pengguna dapat langsung menggunakan layanan ini dengan login menggunakan alamat email @jogjaprov.go.id.'
        }
      ]
    }
  ];

  const callCTA = () => {
    if (user?.attributes?.id) return navigate('/dashboard/requests');
    return navigate('/login');
  };

  return (
    <Stack direction="column" mt={10}>
      {Layanans.map((item, index) => (
        <Item meta={item} index={index + 1} id={item.id} color={item.color} callCTA={callCTA} />
      ))}
    </Stack>
  );
};

const Item = ({ id, color, index, meta, callCTA }) => {
  const theme = useTheme();
  const width = useWidth(useTheme, useMediaQuery);
  return (
    <Fade in="true" mountOnEnter unmountOnExit timeout={2000 + 1000 * index * 0.5}>
      <Box
        id={id}
        pt={10}
        pb={10}
        px={2}
        sx={{
          backgroundImage: `linear-gradient(135deg, ${alpha(color, 0)} 0%, ${alpha(
            color,
            0.24
          )} 100%)`
        }}
      >
        <Container maxWidth="md">
          <Stack direction={!['xs'].includes(width) ? 'row' : 'column'} spacing={4}>
            <Stack direction="column" sx={{ flex: 2 }} alignItems="center">
              <img
                style={{ width: ['xs'].includes(width) ? '70%' : '100%' }}
                src={meta.image}
                alt="Illustration"
              />
            </Stack>

            <Stack direction="column" sx={{ flex: 10 }} spacing={2}>
              <Typography variant="h4" sx={{ color: theme.palette.primary.dark }}>
                {meta.title}
              </Typography>
              <Stack direction="column" sx={{ flex: 10 }} spacing={0.5}>
                {!_.isEmpty(meta.content) &&
                  meta.content.map((metaItem, metaIndex) => (
                    <>
                      {metaItem.type === 'paragraph' && (
                        <Typography variant="body2">{metaItem.value}</Typography>
                      )}
                      {metaItem.type === 'list' &&
                        !_.isEmpty(metaItem.value) &&
                        metaItem.value.map((metaValueItem, metaValueIndex) => (
                          <>
                            <Stack direction="row" spacing={1}>
                              <Typography variant="body2">{metaValueIndex + 1}.</Typography>
                              <Typography variant="body2">{metaValueItem.value}</Typography>
                            </Stack>
                            <Stack direction="column">
                              {!_.isEmpty(metaValueItem.child) &&
                                metaValueItem.child.map(
                                  (metaValueItemChild, metaValueItemIndex) => (
                                    <>
                                      {metaValueItemChild.type === 'paragraph' && (
                                        <Stack direction="row" spacing={1} ml={3}>
                                          <Typography variant="body2">
                                            {(metaValueItemIndex + 1 + 9).toString(36)}.
                                          </Typography>
                                          <Typography variant="body2">
                                            {metaValueItemChild.value}
                                          </Typography>
                                        </Stack>
                                      )}
                                    </>
                                  )
                                )}
                            </Stack>
                          </>
                        ))}
                    </>
                  ))}
              </Stack>
              <Box>
                <Button onClick={callCTA} variant="contained">
                  Ajukan Sekarang
                </Button>
              </Box>
            </Stack>
          </Stack>
        </Container>
      </Box>
    </Fade>
  );
};

LandingSection.propTypes = {
  user: PropTypes.object.isRequired
};

export default LandingSection;
